@switch (kind) {
  @case (IntegrationKind.WEBSITE) {
    <app-crawler-page></app-crawler-page>
  }
}
